import "lazysizes"
import React from 'react';
import { Provider } from 'react-redux'
import store from './src/app/store'

export const wrapRootElement = ({ element }) => {
  return (
    <Provider store={store}>
      {element}
    </Provider>
  )
}

// Registra os event listeners do service worker para notificações
export const onServiceWorkerUpdateReady = () => {
  console.log('🔄 Service Worker atualizado, recarregando...')
  window.location.reload()
}

export const onServiceWorkerActive = ({ serviceWorker }) => {
  console.log('✅ Service Worker ativo')
  console.log('🔒 Protocolo:', window.location.protocol)
  console.log('🌐 Host:', window.location.host)
  
  if (serviceWorker) {
    // Adiciona listeners para notificações
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        console.log('✅ Service Worker pronto para notificações')
        console.log('📍 SW registration:', !!registration)
        console.log('📍 SW scope:', registration.scope)
      }).catch(error => {
        console.error('❌ Erro ao preparar Service Worker:', error)
      })
    }
  }
}
